import type { Store } from "redux";
import type { GlobalState } from "storefront/GlobalState";
import createApp from "../../containers/home";
import ViolationModal from "./ViolationModal";

const render = (node: HTMLElement, store: Store<GlobalState>) =>
  createApp(node, ViolationModal, store);

export default render;
